const closeRelativeContactGroup = "CloseRelative";

export default class ContactUtils {
    /**
     * Twin of ContactGroupNames.RequiresVerification on the server. A contact of somebody else cannot be verified
     * by the user, so no verification requirement may be built on it.
     */
    public static groupRequiresVerification(groupName: string): boolean {
        return groupName !== closeRelativeContactGroup;
    }

    public static handleLoading(modal: JQuery, loading: boolean, loadingClass: string, submitBtnClass: string): void {
        const loadingElement: JQuery = modal.find(loadingClass);
        const submitButton: JQuery = modal.find(submitBtnClass);

        if (loading) {
            loadingElement.show();
            submitButton.addClass("disabled");
            submitButton.prop("disabled", true);
        } else {
            loadingElement.hide();
            submitButton.removeClass("disabled");
            submitButton.prop("disabled", false);
        }
    }
}
